
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.408 7.757H1.592","stroke":"#fff","stroke-width":"2.303","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M7.348 2L1.592 7.757l5.756 5.756","stroke":"#fff","stroke-width":"2.303","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    